/**
 * True when the page is being snapshotted by the build-time prerender step (loaded with
 * `?__prerender=1`). Routes use this to render content in its final, visible state — skipping the
 * preloader and entry animations — so the crawlable HTML is never captured mid-animation or hidden.
 */
export function isPrerender(): boolean {
    if (typeof window === 'undefined') return false;
    return (
        window.location.search.includes('__prerender') ||
        (window as unknown as { __PODUS_PRERENDER__?: boolean }).__PODUS_PRERENDER__ === true
    );
}
